import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { StorefrontService } from '../../core/services/storefront.service';

/** Brand logo mark, optionally with wordmark + kicker. */
@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span style="display:inline-flex;align-items:center" [style.gap.px]="size * 0.5">
      <span [style.height.px]="h" [style.width.px]="h" [style.border-radius.px]="h * 0.24"
        [style.box-shadow]="light ? '0 2px 10px rgba(0,0,0,0.3)' : 'var(--fr-shadow-sm)'"
        style="display:inline-block;overflow:hidden;flex-shrink:0">
        <img [src]="logo" alt="logo" style="height:100%;width:100%;object-fit:contain;transform:scale(1.16);display:block"
          onerror="this.style.display='none'">
      </span>
      <span *ngIf="word" style="display:flex;flex-direction:column;line-height:1">
        <span [style.font-size.px]="size" [style.color]="light ? '#fff' : 'var(--fr-text)'"
          style="font-family:var(--brand-display);font-weight:800;letter-spacing:-0.01em;white-space:nowrap">{{ name }}</span>
        <span *ngIf="kicker" [style.font-size.px]="size * 0.46"
          [style.color]="light ? 'rgba(255,255,255,0.7)' : 'var(--fr-text-3)'"
          [style.margin-top.px]="size * 0.2"
          style="font-weight:600;font-style:italic;letter-spacing:0.01em">{{ tagline }}</span>
      </span>
    </span>`,
})
export class LogoComponent {
  @Input() size = 18;
  @Input() light = false;
  @Input() word = false;
  @Input() kicker = false;

  constructor(private sf: StorefrontService) {}

  get logo(): string { return this.sf.brand?.logo || ''; }
  get name(): string { return this.sf.brand?.name || ''; }
  get tagline(): string { return this.sf.brand?.tagline || ''; }
  get h(): number { return this.size * 2.5; }
}
